//TODO: write function
export const assetUrl = r=>r
